import { makeAutoObservable, runInAction } from 'mobx';
import { Product, Prices } from '../content/ProductInterfaces';
import ErrorUtil from '../error/ErrorUtil';
import ShopAPI from '../util/ShopApiUtil';
import RootStore from './RootStore';
import SsoStore from './SsoStore';

export interface PriceResponse {
  [key: string]: Prices;
}

export default class ProductPriceStore {
  public lastCustomerId: number;
  private ssoStore: SsoStore;
  private originalPrices: PriceResponse = {};

  public constructor(rootStore: RootStore) {
    makeAutoObservable(this, {}, { autoBind: true });
    this.ssoStore = rootStore.ssoStore;
  }

  public fetchPrices = async (productCodes: string[], products: Product[]) => {
    if (!this.ssoStore.customerId) {
      this.restorePricesFromOriginalPrices(products);
      this.updateLastCustomer(this.ssoStore.customerId);
      return;
    }
    if (!productCodes?.length) {
      return;
    }

    try {
      const resp = await ShopAPI.get('/products/prices/multigroup', {
        params: {
          productCodes: productCodes.join(','),
          customerType: this.ssoStore.customerType,
        },
        withCredentials: true,
      });
      this.updateLastCustomer(this.ssoStore.customerId);
      const data: PriceResponse = resp.data;
      this.setPrices(products, data);
    } catch (e) {
      ErrorUtil.pushErrorToTeliaRumAndLog(e as Error);
    }
  };

  private updateLastCustomer(customerId: number) {
    runInAction(() => {
      this.lastCustomerId = customerId;
    });
  }

  private setPrices(products: Product[], response: PriceResponse) {
    products.forEach((product) => {
      if (response[product.productCode]) {
        this.setOriginalPrice(product.productCode, product.prices);
        runInAction(() => {
          product.prices = response[product.productCode];
        });
      }
    });
  }

  private setOriginalPrice(productCode: string, prices: Prices) {
    runInAction(() => {
      this.originalPrices[productCode] = prices;
    });
  }

  private restorePricesFromOriginalPrices(products: Product[]) {
    products.forEach((i) => {
      if (this.originalPrices[i.productCode]) {
        runInAction(() => {
          i.prices = this.originalPrices[i.productCode];
        });
      }
    });
  }
}
